import { useSnackbar } from 'notistack'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import DenseAppBar from '../../components/AppBar'
import Input from '../../components/Input'
import AlertModal from '../../components/Modal'
import { getDate, getDateTime, truncateString } from '../../helpers/Functions'
import { Reducers, Status } from '../../Interfaces/Interfaces'
import { fileUpload } from '../../redux/actions/configActions'
import { getAreasByState, getStates } from '../../redux/actions/LocationAction'
import PrimaryTheme from '../../Themes/Primary';
import OtpInput from 'react-otp-input';
import ExistingAgents from '../../components/ExistingAgents'
import { getAgentDetails, onboardAgents, updateAgent } from '../../redux/actions/AgentActions'
import StatusAlert from '../../components/StatusAlert'


export default function UpdateAgent() {
    const alert = useSelector((state: Reducers) => state.alert);
    const user = useSelector((state: Reducers) => state.user);
    const states = useSelector((state: Reducers) => state.states);
    const areas = useSelector((state: Reducers) => state.areas);
    const file = useSelector((state: Reducers) => state.file);
    const agentDetails = useSelector((state: Reducers) => state.agentDetails);
    const params: any = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    const [newAgent, setNewAgent] = React.useState(true);
    const [page, setPage] = React.useState(1);
    const [gender, setGender] = React.useState('male');
    const [firstnameValid, setFirstnameValid]: any = React.useState(null);
    const [lastnameValid, setLastnameValid]: any = React.useState(null);
    const [dob, setDob]: any = React.useState("");
    const [email, setEmail] = React.useState('');
    // const [confirmEmail, setConfirmEmail] = React.useState('');
    const [isEmailValid, setEmailValid]: any = React.useState(null);
    const [isMatched, setIsMatched]: any = React.useState(null);
    const [submitted] = React.useState(false);
    const [firstName, setFirstname] = React.useState(agentDetails.firstName ? agentDetails.firstName : "");
    const [lastName, setLastname] = React.useState('');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [phoneNumberValid, setPhoneNumberValid]: any = React.useState(null);
    const [confirmPhoneNumber, setConfirmPhoneNumber] = React.useState('');
    // const [ConfirmPhoneNumberValid, setConfirmPhoneNumberValid]: any = React.useState(null);
    const [address, setAddress] = React.useState('');
    const [stateId, setStateId] = React.useState('');
    const [lgaId, setLgaId] = React.useState('');
    const [BVN, setBVN] = React.useState('');
    const [meansOfIdentification, setMeansOfIdentification] = React.useState('');
    const [id] = React.useState('');
    const [idName, setIdName] = React.useState('Choose file...');
    const [passportName, setPassportName] = React.useState('Choose file...');
    const [utilityName, setUtilityName] = React.useState('Choose file...');
    const [passport] = React.useState('');
    const [utility] = React.useState('');
    const [pin, setPin] = React.useState('');
    const [loading, setloading] = React.useState(false);


    const validateName = (text: any, type: any) => {
        // minimum of one character
        let reg = /^[a-zA-Z]{1,}$/;
        if (!reg.test(text)) {

            if (type === 'firstname') {
                setFirstname(text);
                setFirstnameValid(false);
            } else {
                setLastname(text);
                setLastnameValid(false);
            }
        } else {
            if (type === 'firstname') {
                setFirstname(text);
                setFirstnameValid(true);
            } else {
                setLastname(text);
                setLastnameValid(true);
            }
        }
    };

    // const isEmailMatch = (text: string) => {
    //     setConfirmEmail(text);

    //     if (email === text) {
    //         setIsMatched(true);
    //     } else {
    //         setIsMatched(false);
    //     }
    // }

    // const isPhoneMatch = (text: string) => {
    //     setConfirmPhoneNumber(text);

    //     if (phoneNumber === text) {
    //         setConfirmPhoneNumberValid(true);
    //     } else {
    //         setConfirmPhoneNumberValid(false);
    //     }
    // }

    const validateEmail = (text: string) => {
        // email pattern
        let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/;
        if (!reg.test(text)) {
            setEmailValid(false);
            setEmail(text.toLowerCase());
        } else {
            setEmailValid(true);
            setEmail(text);
        }
    };

    const validatePhoneNumber = (text: string) => {
        // email pattern
        let reg = /^[0-9]{11,11}$/;
        if (!reg.test(text)) {
            setPhoneNumberValid(false);
            setPhoneNumber(text.toLowerCase());
        } else {
            setPhoneNumberValid(true);
            setPhoneNumber(text);
        }
    };

    const handleRefresh = () => {
        dispatch({
            type: 'LOADING',
            payload: true
        });
        // dispatch(getAgents(paginationConfig));
    }

    const handleFile = (e: any, type: string) => {
        let pic = e[0];
        let fd = new FormData();
        if (pic) {
            fd.append('imageUrl', pic)
            dispatch(fileUpload(fd, type))
            dispatch({
                type: 'LOADING',
                payload: true
            })

        }
    }

    const handleOTP = (e: any) => {
        e.preventDefault();

        dispatch({
            type: 'ALERT_MODAL',
            payload: true
        })
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setloading(true)
        // dispatch({
        //     type: 'LOADING',
        //     payload: true
        // });

        // dispatch({
        //     type: 'ALERT_MODAL',
        //     payload: false
        // })
        let agentUpdate = {
            id: params.id,
            name: firstName + ' ' + lastName,
            firstName: firstName,
            lastName: lastName,
            address: address,
            email: email,
            logo: passportName === "Choose file..." ? "" : passportName,
            identificationType: meansOfIdentification,
            birthday: dob,
            identificationDocumentUrl: idName === "Choose file..." ? "" : idName,
            bankVerificationNumber: BVN,
            gender: gender,
            utilityBill: utilityName === "Choose file..." ? "" : utilityName,
            aggregatorId: user.id,
            stateId: stateId,
            lgaId: lgaId,
            pin: pin,
            bankId: '96',
            // accountNumber: '5000000000',
        }


        dispatch(updateAgent(agentUpdate));

    }

    const handleState = (state: string) => {
        setStateId(state)

        dispatch(getAreasByState(state))

    }

    React.useEffect(() => {

        if (Object.entries(file).length !== 0) {
            switch (file.fileType) {
                case "id": {
                    setIdName(file.fileName);
                    break;
                }

                case "passport": {
                    setPassportName(file.fileName)
                    break;
                }

                case "utility": {
                    setUtilityName(file.fileName)
                    break;
                }

                default:
                    return;
            }
        }

    }, [file]);

    React.useEffect(() => {

        dispatch(getStates());

        dispatch(getAgentDetails(params.id));
    }, [dispatch]);

    React.useEffect(() => {
        dispatch({ type: "STATUS_ALERT", payload: false })
        if (Object.entries(agentDetails).length !== 0) {
            dispatch(getAreasByState(agentDetails.stateId))
            setFirstname(agentDetails.firstName)
            setLastname(agentDetails.lastName)
            setEmail(agentDetails.email)
            setMeansOfIdentification(agentDetails.identificationType)
            setPhoneNumber(agentDetails.phoneNumber);
            setGender(agentDetails.gender ? agentDetails.gender : "male")
            setAddress(agentDetails.address)
            setDob(getDate(agentDetails.birthday))
            setStateId(agentDetails.stateId)
            setLgaId(agentDetails.lgaId)
            setBVN(agentDetails.bankVerificationNumber)
            setIdName(agentDetails.identificationDocumentUrl ? agentDetails.identificationDocumentUrl : 'Choose file...')
            setPassportName(agentDetails.logo ? agentDetails.logo : 'Choose file...')
            setUtilityName(agentDetails.utilityBill ? agentDetails.utilityBill : 'Choose file...')
        }
    }, [agentDetails]);


    const closeModal = () => {
        setPage(1);
        dispatch({ type: "ALERT_MODAL", payload: false })
        dispatch({ type: "STATUS_ALERT", payload: false })
    }

    const closeAlert = () => {
        setPage(1);
        dispatch({ type: "STATUS_ALERT", payload: false });
        window.location.reload();
    }

    React.useEffect(() => {
        if (Object.entries(alert).length !== 0) {
            if (!alert.successful) {
                // display error message
                enqueueSnackbar(alert.message, { variant: "error" });

                setPin("")
                dispatch({
                    type: 'LOADING',
                    payload: false
                })

                dispatch({
                    type: 'ALERT',
                    payload: {}
                });

            } else {

                handleRefresh();
                setloading(false)
                setPin("")

                if (alert.message === "Successful") {
                    dispatch(getAgentDetails(params.id));
                    history.push("/agents/details/" + params.id)
                    dispatch({ type: "ALERT_MODAL", payload: false })
                    dispatch({
                        type: "STATUS_ALERT",
                        payload: true
                    });
                }

                dispatch({
                    type: 'LOADING',
                    payload: false
                })

                dispatch({
                    type: 'ALERT',
                    payload: {}
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, enqueueSnackbar, alert, history]);
    const [switchDate, setswitchDate] = React.useState(false)
    const handleChangeDate = () => {
        if (switchDate) {
            setswitchDate(false)
        } else {
            setswitchDate(true)
        }

    }

    return (
        <React.Fragment>
            <div className="col-md-11 mr-auto ml-auto p-0" style={{
                height: 'auto',
                position: "relative",
            }}>
                <DenseAppBar
                    canGoBack
                    onClick={() => history.goBack()}
                />
            </div>
            <div className='col-md-12 pl-0 pr-0' style={{
                // overflow: "auto",
                backgroundColor: PrimaryTheme.white,
                minHeight: '100vh',
                height: "auto"
            }}>

                <div className="col-md-11 ml-auto mr-auto p-0" style={{
                    backgroundColor: PrimaryTheme.white,
                    height: '100vh',
                    position: 'relative',
                    // zIndex: 1000,
                }}>
                    <h1 className="mb-5 agent-title" style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        textTransform: "uppercase",
                        fontSize: PrimaryTheme.fontSizes?.subtitle,

                    }}>
                        Update Agent
                    </h1>

                    <div className="row mb-5" style={{ paddingLeft: "20px", paddingRight: "20px" }}>

                        {/* <div className="col-md-12 mb-3">
                            <div className="input-group mb-3 col-md-6 ml-auto mr-auto">
                                <div className="input-group-prepend w-50">
                                    <button className={newAgent ? "btn btn-warning w-100 btn-lg" : "w-100 btn-light border"} type="button" style={{
                                        borderRadius: "20px 0 0 20px"
                                    }} onClick={() => setNewAgent(!newAgent)}>Add New Agent</button>
                                </div>

                                <div className="input-group-append w-50">
                                    <button className={!newAgent ? "btn btn-warning w-100 btn-lg" : "w-100 btn-light border"} type="button" style={{
                                        borderRadius: "0 20px 20px 0"
                                    }} onClick={() => setNewAgent(!newAgent)}>Map Registered Agent</button>
                                </div>
                            </div>
                            {newAgent &&
                                <h6 className="text-center" style={{
                                    fontFamily: PrimaryTheme.fonts?.LightFont,
                                    color: PrimaryTheme.dark,
                                }}>Register a new agent which would be mapped to your aggregator account instantly</h6>
                            }
                        </div> */}

                        <div className="col-md-6 ml-auto mr-auto mb-5" style={{ paddingBottom: "100px" }}>

                            <form noValidate>
                                {newAgent && page === 1 && <React.Fragment>

                                    <div className="form-group">
                                        <label htmlFor="firstname" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Firstname</label>
                                        <Input
                                            type='text'
                                            placeholder='Enter First Name'
                                            autoComplete="firstname"
                                            showIcon
                                            required
                                            id="firstname"
                                            valid={firstnameValid}
                                            value={firstName}
                                            disabled={submitted}
                                            inputMode="text"
                                            onChange={e => validateName(e.target.value, "firstname")}
                                            isInput style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC"
                                            }} />
                                    </div>

                                    <div className="form-group mt-4">
                                        <label htmlFor="lastname" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Lastname</label>
                                        <Input
                                            type='text'
                                            placeholder='Enter Last Name'
                                            autoComplete="lastname"
                                            showIcon
                                            required
                                            id="lastname"
                                            valid={lastnameValid}
                                            value={lastName}
                                            disabled={submitted}
                                            inputMode="text"
                                            onChange={e => validateName(e.target.value, "lastname")}
                                            isInput style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC"
                                            }} />
                                    </div>

                                    <div className="form-group mt-4">
                                        <label htmlFor="email" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Email Address</label>
                                        <Input
                                            type='email'
                                            placeholder='Enter Email Address'
                                            autoComplete="email"
                                            showIcon
                                            required
                                            id="email"
                                            valid={isEmailValid}
                                            value={email}
                                            disabled
                                            inputMode="email"
                                            onChange={e => validateEmail(e.target.value)}
                                            isInput style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC"
                                            }} />
                                    </div>

                                    {/* <div className="form-group mt-4">
                                        <label htmlFor="confirmEmail" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Confirm Email Address</label>
                                        <Input
                                            type='email'
                                            placeholder='Confirm Email Address'
                                            autoComplete="email"
                                            showIcon
                                            required
                                            id="confirmEmail"
                                            valid={isMatched}
                                            value={confirmEmail}
                                            disabled={submitted}
                                            inputMode="email"
                                            onChange={e => isEmailMatch(e.target.value)}
                                            isInput style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC"
                                            }} />
                                    </div> */}

                                    <div className="form-group mt-4">
                                        <label htmlFor="phoneNumber" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Phone Number</label>
                                        <Input
                                            type='tel'
                                            placeholder='Enter Phone Number'
                                            autoComplete="phoneNumber"
                                            showIcon
                                            required
                                            id="phoneNumber"
                                            valid={phoneNumberValid}
                                            value={phoneNumber}
                                            disabled
                                            inputMode="tel"
                                            onChange={e => validatePhoneNumber(e.target.value)}
                                            isInput style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC"
                                            }} />
                                    </div>

                                    {/* <div className="form-group mt-4">
                                        <label htmlFor="confirmPhoneNumber" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Confirm Phone Number</label>
                                        <Input
                                            type='tel'
                                            placeholder='Confirm Phone Number'
                                            autoComplete="phoneNumber"
                                            showIcon
                                            required
                                            id="confirmPhoneNumber"
                                            valid={ConfirmPhoneNumberValid}
                                            value={confirmPhoneNumber}
                                            disabled={submitted}
                                            inputMode="tel"
                                            onChange={e => isPhoneMatch(e.target.value)}
                                            isInput style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC"
                                            }} />
                                    </div> */}

                                    <div className="form-group mt-4">
                                        <label htmlFor="dob" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Date of Birth</label>
                                        {
                                            dob ? !switchDate ? <div style={{ position: "relative" }}>
                                                <div onClick={handleChangeDate} style={{ position: "absolute", left: "80%", zIndex: 1000, borderRadius: "20px", backgroundColor: PrimaryTheme.warn, border: "none", paddingLeft: "20px", paddingRight: "20px", cursor: "pointer", top: "-40%" }}>Change</div>
                                                <Input

                                                    type='text'
                                                    required
                                                    id="dob"
                                                    value={dob}
                                                    disabled

                                                    isInput style={{
                                                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                        color: PrimaryTheme.dark,
                                                        background: "#F4F7FC"
                                                    }} />
                                            </div> : <div style={{ position: "relative" }}>
                                                <div onClick={handleChangeDate} style={{ position: "absolute", left: "80%", zIndex: 1000, borderRadius: "20px", backgroundColor: PrimaryTheme.warn, border: "none", paddingLeft: "20px", paddingRight: "20px", cursor: "pointer", top: "-40%" }}>Change</div><Input

                                                    type='date'
                                                    required
                                                    id="dob"
                                                    value={dob}
                                                    disabled={submitted}
                                                    onChange={e => setDob(e.target.value)}
                                                    isInput style={{
                                                        fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                        color: PrimaryTheme.dark,
                                                        background: "#F4F7FC"
                                                    }} /></div> : <Input

                                                type='date'
                                                required
                                                id="dob"
                                                value={dob}
                                                disabled={submitted}
                                                onChange={e => setDob(e.target.value)}
                                                isInput style={{
                                                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                    color: PrimaryTheme.dark,
                                                    background: "#F4F7FC"
                                                }} />
                                        }


                                    </div>

                                    <div className="form-group mt-4">
                                        <label style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Gender</label>

                                        <div className="input-group mb-3 col-md-12 ml-auto mr-auto">
                                            <div className="input-group-prepend w-50">
                                                <button className={gender === "male" ? "btn btn-warning w-100 btn-lg" : "w-100 btn-light border"} type="button" style={{
                                                    borderRadius: "20px 0 0 20px",
                                                    paddingTop: "10px",
                                                    paddingBottom: "10px"
                                                }} onClick={() => setGender("male")}>Male</button>
                                            </div>

                                            <div className="input-group-append w-50">
                                                <button className={gender === 'female' ? "btn btn-warning w-100 btn-lg" : "w-100 btn-light border"} type="button" style={{
                                                    borderRadius: "0 20px 20px 0"
                                                }} onClick={() => setGender("female")}>Female</button>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="form-group mt-5 col-md-8 ml-auto mr-auto">
                                        <Input
                                            onClick={() => setPage(2)}
                                            type='submit'
                                            isInput
                                            value='Continue'
                                            disabled={!firstName || !lastName || !email || !phoneNumber || !dob}
                                            style={{
                                                background: PrimaryTheme.primary,
                                                fontFamily: PrimaryTheme.fonts?.MediumFont,
                                                color: PrimaryTheme.white
                                            }} className='text-bold border-0' />
                                    </div>
                                </React.Fragment>}

                                {newAgent && page === 2 && <React.Fragment>

                                    <div className="form-group">
                                        <label htmlFor="address" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Address</label>
                                        <Input
                                            type='text'
                                            placeholder='Enter Current Address'
                                            autoComplete="address"
                                            showIcon
                                            required
                                            id="address"
                                            value={address}
                                            disabled={submitted}
                                            inputMode="text"
                                            onChange={e => setAddress(e.target.value)}
                                            isInput style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC"
                                            }} />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="state" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>State</label>
                                        <select className="custom-select" value={stateId} onChange={(e) => handleState(e.target.value)} style={{
                                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                                            color: PrimaryTheme.dark,
                                            backgroundColor: "#F4F7FC",
                                            borderRadius: 25,
                                            border: '1px solid white',
                                            padding: 15,
                                            height: "auto",
                                            boxShadow: "none"
                                        }}>
                                            <option value="1">Select State of Residence</option>
                                            {states ? states.map((item: Status, index: number) => (
                                                <option key={index} value={item.id}>{item.name}</option>
                                            )) : ""}
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="lga" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>LGA</label>
                                        <select className="custom-select"
                                            value={lgaId}
                                            onChange={(e) => setLgaId(e.target.value)}
                                            disabled={stateId === '' ? true : false}
                                            style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                backgroundColor: "#F4F7FC",
                                                borderRadius: 25,
                                                border: '1px solid white',
                                                padding: 15,
                                                height: "auto",
                                                boxShadow: "none"
                                            }}>
                                            <option value="1">Select LGA of Residence</option>
                                            {areas && areas.map((item: Status, index: number) => (
                                                <option key={index} value={item.id}>{item.name}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="bvn" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>BVN</label>
                                        <Input
                                            type='text'
                                            placeholder='Enter BVN'
                                            autoComplete="text"
                                            showIcon
                                            required
                                            id="bvn"
                                            value={BVN}
                                            disabled={submitted}
                                            inputMode="text"
                                            onChange={e => setBVN(e.target.value)}
                                            isInput style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                background: "#F4F7FC"
                                            }} />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="meansOfIdentification" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Means Of Identification</label>
                                        <select className="custom-select"
                                            value={meansOfIdentification}
                                            onChange={(e) => setMeansOfIdentification(e.target.value)}
                                            style={{
                                                fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                color: PrimaryTheme.dark,
                                                backgroundColor: "#F4F7FC",
                                                borderRadius: 25,
                                                border: '1px solid white',
                                                padding: 15,
                                                height: "auto",
                                                boxShadow: "none"
                                            }}>
                                            <option value="Drivers License">Drivers License</option>
                                            <option value="International Passport">International Passport</option>
                                            <option value="National ID">National ID</option>
                                            <option value="Voters Card">Voters Card</option>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <h6 className="w-100" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Government ID</h6>

                                        <label htmlFor="id" style={{
                                            color: PrimaryTheme.dark,
                                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                                            background: "#F4F7FC",
                                            borderRadius: 25,
                                            border: '1px solid white',
                                            padding: 15,
                                            height: "auto",
                                            boxShadow: "none",
                                            width: "100%",
                                            cursor: 'pointer'
                                        }}>
                                            <input
                                                type='file'
                                                placeholder='Upload Government ID'
                                                id="id"
                                                name="id"
                                                value={id}
                                                disabled={submitted}
                                                onChange={e => handleFile(e.currentTarget.files, 'id')}
                                                style={{
                                                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                    color: PrimaryTheme.dark,
                                                    background: "#F4F7FC",
                                                    display: "none"
                                                }} />

                                            <div className="row justify-content-between align-items-center m-0">
                                                <span>{truncateString(idName, 30)}</span>
                                                <span className="badge badge-pill badge-warning p-2 pl-3 pr-3 btn-lg" style={{
                                                    fontSize: PrimaryTheme.fontSizes?.normal
                                                }}>{idName !== 'Choose file...' ? "Change" : "Upload"}</span>
                                            </div>
                                        </label>
                                    </div>

                                    <div className="form-group">
                                        <h6 className="w-100" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Passport</h6>

                                        <label htmlFor="passport" style={{
                                            color: PrimaryTheme.dark,
                                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                                            background: "#F4F7FC",
                                            borderRadius: 25,
                                            border: '1px solid white',
                                            padding: 15,
                                            height: "auto",
                                            boxShadow: "none",
                                            width: "100%",
                                            cursor: 'pointer'
                                        }}>
                                            <input
                                                type='file'
                                                placeholder='Upload Passport'
                                                id="passport"
                                                value={passport}
                                                disabled={submitted}
                                                onChange={e => handleFile(e.currentTarget.files, 'passport')}
                                                style={{
                                                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                    color: PrimaryTheme.dark,
                                                    background: "#F4F7FC",
                                                    display: "none"
                                                }} />

                                            <div className="row justify-content-between align-items-center m-0">
                                                <span>{truncateString(passportName, 30)}</span>
                                                <span className="badge badge-pill badge-warning p-2 pl-3 pr-3 btn-lg" style={{
                                                    fontSize: PrimaryTheme.fontSizes?.normal
                                                }}>{passportName !== 'Choose file...' ? "Change" : "Upload"}</span>
                                            </div>
                                        </label>
                                    </div>

                                    <div className="form-group">
                                        <h6 className="w-100" style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                        }}>Utility Bill</h6>

                                        <label htmlFor="utility" style={{
                                            color: PrimaryTheme.dark,
                                            fontFamily: PrimaryTheme.fonts?.RubikLight,
                                            background: "#F4F7FC",
                                            borderRadius: 25,
                                            border: '1px solid white',
                                            padding: 15,
                                            height: "auto",
                                            boxShadow: "none",
                                            width: "100%",
                                            cursor: 'pointer'
                                        }}>
                                            <input
                                                type='file'
                                                placeholder='Upload Utility Bill'
                                                id="utility"
                                                value={utility}
                                                disabled={submitted}
                                                onChange={e => handleFile(e.currentTarget.files, 'utility')}
                                                style={{
                                                    fontFamily: PrimaryTheme.fonts?.RubikLight,
                                                    color: PrimaryTheme.dark,
                                                    background: "#F4F7FC",
                                                    display: "none"
                                                }} />

                                            <div className="row justify-content-between align-items-center m-0">
                                                <span>{truncateString(utilityName, 30)}</span>
                                                <span className="badge badge-pill badge-warning p-2 pl-3 pr-3 btn-lg" style={{
                                                    fontSize: PrimaryTheme.fontSizes?.normal
                                                }}>{utilityName !== 'Choose file...' ? "Change" : "Upload"}</span>
                                            </div>
                                        </label>
                                    </div>

                                    <div className="form-group mt-5 col-md-8 ml-auto mr-auto text-center">
                                        <Input
                                            onClick={handleOTP}
                                            type='button'
                                            isInput
                                            value='Continue'
                                            disabled={idName === "Choose file..." || passportName === "Choose file..."}
                                            // disabled={idName === "Choose file..." || passportName === "Choose file..." || utilityName === "Choose file..."}
                                            style={{
                                                background: PrimaryTheme.primary,
                                                fontFamily: PrimaryTheme.fonts?.MediumFont,
                                                color: PrimaryTheme.white
                                            }} className='text-bold border-0' />
                                        <button className="btn btn-light" onClick={() => setPage(1)}>Back</button>
                                    </div>
                                </React.Fragment>}

                            </form>


                            {!newAgent && <ExistingAgents />}
                        </div>
                    </div>
                </div>

                <AlertModal>
                    <div className="col-md-12 p-5 text-center">
                        <div className="col-md-12">
                            <span className="badge-pill p-3 d-block col-7 ml-auto mr-auto" style={{
                                background: PrimaryTheme.warn,
                                fontFamily: PrimaryTheme.fonts?.MediumFont,
                            }}>Enter PIN</span>
                        </div>

                        <p className="mt-3 mb-5" style={{
                            fontFamily: PrimaryTheme.fonts?.RegularFont,
                            fontSize: 18,
                            color: PrimaryTheme.light
                        }}>Enter your 4 Digit Transaction PIN to confirm this registration</p>

                        <div className="row m-0 justify-content-center align-items-center">
                            <OtpInput
                                value={pin}
                                onChange={(e: any) => setPin(e)}
                                numInputs={4}
                                isInputNum
                                shouldAutoFocus
                                inputStyle={{
                                    width: '45px',
                                    height: '45px',
                                    fontSize: '24px',
                                    padding: 0,
                                    textAlign: 'center',
                                    borderRadius: 10,
                                    border: "1px solid",
                                    borderColor: PrimaryTheme.primary
                                }}
                                isInputSecure
                                separator={<span className="mr-3">  </span>}
                            />
                        </div>

                        <div className="form-group mt-5 mb-0">
                            <Input
                                onClick={handleSubmit}
                                type='button'
                                isInput
                                value={loading ? "Updating..." : 'Update Agent'}
                                disabled={pin.length === 0}
                                style={{
                                    background: PrimaryTheme.primary,
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    color: PrimaryTheme.white
                                }} className='text-bold border-0 col-md-6' />
                            <button className="btn btn-light" onClick={closeModal}>Back</button>
                        </div>
                    </div>
                </AlertModal>

                <StatusAlert
                    subtitle="Agent profile updated successful"
                    title={firstName + " Successfully updated"}
                    buttonTitle="Update Agent"
                    backTitle="Back to agents"
                    onClick={closeAlert}
                    goBack={() => history.push('/agents')}
                ></StatusAlert>

            </div>
        </React.Fragment >
    )
}
